import Headers from './components/Headers.vue'
import Footers from './components/Footers.vue'
import Group from './components/Group.vue'
import Hero from './components/Hero.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import Swiper from './components/Swiper.vue'
import Carousel from './components/Carousel.vue'
import Btn from './components/Btn.vue'
import Faq from './components/Faq.vue'
import Slice from './components/Slice.vue'
import Bnr from './components/Bnr.vue'
import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        Headers: Headers,
        Footers: Footers,
        Group: Group,
        Hero: Hero,
        Breadcrumb: Breadcrumb,
        Swiper: Swiper,
        Carousel: Carousel,
        Btn: Btn,
        Faq: Faq,
        Slice: Slice,
        Bnr: Bnr,
      }
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
